<img (click)="btnClick.emit()" src="../../../../assets/icons/close.svg" alt="alt">
